window.TRNMNT_sendData = require('./tools/dataSend').default;
window.TRNMNT_deleteData = require('./tools/dataDelete').default;
window.TRNMNT_helpers = require('./tools/helpers').default;

// import.meta.glob([
//     '../images/**',
// ]);

window.ImageUploader = require('./tools/imageUploader').ImageUploader;

window.tempusdominus = require('@eonasdan/tempus-dominus');

// window.Alpine = require('alpinejs');

// Alpine.start();

//Bootstrap tooltips
$(document).ready(() => {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));

    $(document).on('change', 'input[type=checkbox]', event => {
        event.target.value = event.target.checked ? 'on' : 'off';
    });

    $(".tabs").each(function () {
        let $this = $(this);
        if ($this.hasClass('tabs_masonry')) {
            const msnry = new Masonry('.tabs_masonry .tab .row', {
                percentPosition: true,
                itemSelector: '.grid-item',
            });
        }

        $this.find(".tabs__titles").first().on("click", "li", function () {
            const $li = $(this);
            let id = $li.data("id");

            console.log(`[app] tab data ID = ${id}`);

            $li.siblings().removeClass("active");
            $li.addClass("active");

            const $tabs = $this.find(".tab");
            console.log(`[app] $tabs.length = ${$tabs.length}`);
            if ($tabs.length) {
                $this.find(".tab").hide();
                $this.find(".tab-" + id).show();
            }
        });
    });

    new Swiper(".matches-results", {
        slidesPerView: "auto",
        variableWidth: true,
        navigation: {
            nextEl: '.matches-results-wrap .swiper-button-next',
            prevEl: '.matches-results-wrap .swiper-button-prev',
        },
        observer: true,
        observeParents: true,
        breakpoints: {
            320: {
                spaceBetween: 15,
                slidesPerView: 3,
                variableWidth: false,
            },
            576: {
                variableWidth: true,
                slidesPerView: "auto",
            }
        }
    });

    $(document).on("click", ".navbar-toggler", function () {
        $("body").toggleClass("hidden");
    });
});

Date.prototype.getShortDate = function (delimiter = '.', inverse = false) {
    const day = String(this.getDate()).padStart(2, '0');
    const month = String(this.getMonth() + 1).padStart(2, '0');

    if (!inverse) return day + delimiter + month + delimiter + this.getFullYear();

    return this.getFullYear() + delimiter + month + delimiter + day;
};

/**
 * Получить дату со временем.
 * @param {String} [delimiter]
 * @returns {String}
 */
Date.prototype.getFullDate = function (delimiter = '.', comma = false) {
    const day = String(this.getDate()).padStart(2, '0');
    const month = String(this.getMonth() + 1).padStart(2, '0');
    const hour = String(this.getHours()).padStart(2, '0');
    const minute = String(this.getMinutes()).padStart(2, '0');

    return day + delimiter + month + delimiter + this.getFullYear() + (comma ? ',' : '') + ' ' + hour + ':' + minute;
};

Date.prototype.getTimeString = function () {
    const hour = String(this.getHours()).padStart(2, '0');
    const minute = String(this.getMinutes()).padStart(2, '0');

    return hour + ':' + minute;
};

Date.prototype.getWeekDay = function () {
    switch (this.getDay()) {
        case 0:
            return 'воскресенье';
        case 1:
            return 'понедельник';
        case 2:
            return 'вторник';
        case 3:
            return 'среда';
        case 4:
            return 'четверг';
        case 5:
            return 'пятница';
        case 6:
            return 'суббота';
    }
};

/**
 * Получить объект даты начала дня
 * @returns {Date}
 */
Date.prototype.getDayBegin = function () {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate(), 0, 0, 0);
};

/**
 * Подставить данные в строку
 * @link http://habrahabr.ru/post/192124/#comment_6673074
 * @returns {string}
 */
String.prototype.format = function () {
    let i = -1;
    const args = arguments;

    return this.replace(/#\{(.*?)\}/g, function (_, two) {
        return (typeof args[0] === 'object') ? args[0][two] : args[++i];
    });
};
